import { useQuery, useQueryClient } from '@tanstack/react-query'
import type { UseQueryOptions } from '@tanstack/react-query'
import { getWorkAuthorizationExpirationReport } from 'api/admin/i9/getWorkAuthorizationExpirationReport'
import { i9AdminKeys } from './keys'

type WorkAuthorizationExpirationReport = Awaited<
  ReturnType<typeof getWorkAuthorizationExpirationReport>
>

export const useWorkAuthorizationExpirationReport = (
  options?: Partial<
    UseQueryOptions<
      WorkAuthorizationExpirationReport,
      Error,
      WorkAuthorizationExpirationReport,
      ReturnType<typeof i9AdminKeys.workAuthorizationExpirationReport>
    >
  >
) => {
  return useQuery({
    queryKey: i9AdminKeys.workAuthorizationExpirationReport(),
    queryFn: getWorkAuthorizationExpirationReport,
    staleTime: 1000 * 60, // 1 minute
    ...options,
  })
}

export const useInvalidateWorkAuthorizationExpirationReport = () => {
  const queryClient = useQueryClient()

  return function invalidateWorkAuthorizationExpirationReport() {
    queryClient.invalidateQueries({
      queryKey: i9AdminKeys.workAuthorizationExpirationReport(),
    })
  }
}
